import { Component } from "react";
import { connect } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { hideAddNewItemsNamesModal } from "../redux-state/features/storeMgmt/storeMgmtSlice";
import { faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { showSuccess, showError } from "../utils";
import urls from "../urls";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

class AddNewItemsNamesToStore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      newItem: { uuid: "", item_name: "" },
      editItemId: null,
      editItemName: "",
    };
  }

  handleInputChange = (e) => {
    this.setState({
      newItem: { ...this.state.newItem, item_name: e.target.value },
    });
  };

  handleAddItem = (e) => {
    if (e.key === "Enter" && this.state.newItem.item_name.trim()) {
      const newItem = {
        uuid: uuidv4(),
        item_name: this.state.newItem.item_name.trim(),
      };
      this.setState({
        items: [...this.state.items, newItem],
        newItem: { uuid: "", item_name: "" },
      });
    }
  };

  showEditItem = (uuid) => {
    const item = this.state.items.find((item) => item.uuid === uuid);
    this.setState({ editItemId: uuid, editItemName: item.item_name });
  };

  handleEditItem = (e) => {
    if (e.key === "Enter" && this.state.editItemName.trim()) {
      const updatedItems = this.state.items.map((item) =>
        item.uuid === this.state.editItemId
          ? { ...item, item_name: this.state.editItemName.trim() }
          : item
      );
      this.setState({
        items: updatedItems,
        editItemId: null,
        editItemName: "",
      });
    }
  };

  handleDeleteItem = (uuid) => {
    const filteredItems = this.state.items.filter((item) => item.uuid !== uuid);
    this.setState({ items: filteredItems });
  };

  handleSaveChanges = () => {
    const { additionType } = this.props;

    const config =
      additionType === "item"
        ? {
            url: urls.saveNewItemsNames,
            successMessage: "تم إضافة العناصر بنجاح ",
            errorMessage: "لم يتم حفظ التغييرات بنجاح ",
          }
        : {
            url: urls.addNewSupplier,
            successMessage: "تم حفظ أسماء الموردون بنجاح",
            errorMessage: "لم يتم حفظ أسماء الموردون بنجاح",
          };
    axios
      .post(config.url, {
        faculty_id: this.props.faculty_id,
        itemsArray: this.state.items,
      })
      .then((response) => {
        showSuccess(config.successMessage);
        this.handleClose();
      })
      .catch((error) => {
        console.log(error);
        showError(config.errorMessage);
      });
  };

  handleClose = () => {
    this.props.hideAddNewItemsNamesModal();
    this.setState({ items: [] });
  };

  render() {
    const { show, additionType } = this.props;
    const { items, newItem, editItemId, editItemName } = this.state;

    const config =
      additionType === "item"
        ? {
            title: "    إضافة اسماء مواد جديدة الى المخزن",
          }
        : { title: "إضافة أسماء موردين" };
    return (
      <Modal
        show={show}
        onHide={this.handleClose}
        backdrop="static"
        keyboard={false}
        size="sm"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "11px" }}>{config.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            className="form-control"
            placeholder="أدخل اسم المادة ثمّ اضغظ مفتاح   ENTER "
            value={newItem.item_name}
            onChange={this.handleInputChange}
            onKeyDown={this.handleAddItem}
            style={{ fontSize: "11px" }}
          />
          {items.length > 0 && (
            <table className="table mt-3">
              <thead>
                <tr>
                  <th>اسم المادة</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={item.uuid}>
                    <td>
                      {editItemId === item.uuid ? (
                        <input
                          type="text"
                          className="form-control"
                          value={editItemName}
                          onChange={(e) =>
                            this.setState({ editItemName: e.target.value })
                          }
                          onKeyDown={this.handleEditItem}
                        />
                      ) : (
                        item.item_name
                      )}
                    </td>
                    <td>
                      <button
                        className="btn border border-1"
                        title=""
                        onClick={() => this.showEditItem(item.uuid)}
                      >
                        <FontAwesomeIcon icon={faPen} size="lg" />
                      </button>
                      <button
                        className="btn border border-1 ms-3"
                        onClick={() => this.handleDeleteItem(item.uuid)}
                      >
                        <FontAwesomeIcon icon={faTrashCan} title="" size="lg" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose}>
            إلغاء العملية
          </Button>
          <Button variant="primary" onClick={this.handleSaveChanges}>
            حفظ التغييرات
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapDispatchToProps = { hideAddNewItemsNamesModal };
const mapStateToProps = (state) => ({
  show: state.StoreState.showAddNewItemsNamesModal,
  additionType: state.StoreState.storeItemAddType,
  faculty_id: state.userState.faculty_id,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddNewItemsNamesToStore);
